module.exports = __webpack_public_path__ + "static/media/pig.77fb6a50.svg";